/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { HamburgerIcon } from '@chakra-ui/icons';

import {
  Button,
  chakra,
  Flex,
  Hide,
  HStack,
  IconButton,
  Image,
  Show,
  Spacer,
  Link,
  Text,
} from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';
import logo from '../../images/logo.svg';
import { LandtokenLogin, LandtokenSignUp } from '../../utils/urls';

function Header(): JSX.Element {
  const { t } = useTranslation('header');
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (isOpen && typeof window !== 'undefined') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  return (
    <chakra.header borderBottom="1px" borderColor="borders.200" id="main">
      <Flex px={{ base: 4, lg: 12 }} h="70px" justify="space-between" align="center">
        <Link href="/">
          <Image src={logo} alt="landtoken" w="166px" />
        </Link>
        <Show above="lg">
          <Spacer />
          <HStack fontSize="sm" color="gray.700" spacing="24px">
            <Link href="/#invest-in-land">{t('invest-in-land')}</Link>
            <Link href="/#why">{t('why-buy')}</Link>
            <Link href="/team">{t('who-we-are')}</Link>
            <Link href="/faqs">{t('frequent-questions')}</Link>
            <Link href="/#help-center">{t('help-center')}</Link>
          </HStack>
          <Spacer />
          <Link href={LandtokenSignUp} target="_blank">
            <Text fontSize="sm" color="gray.700" decoration="underline" marginRight="4">
              {t('sign-up', 'Registrate')}
            </Text>
          </Link>
          <Link href={LandtokenLogin} target="_blank">
            <Button variant="outline" fontWeight="normal" fontSize="sm">
              {t('sign-in', 'Iniciar sesión')}
            </Button>
          </Link>
        </Show>
        <Hide above="lg">
          <IconButton
            aria-label="open menu"
            fontSize="20px"
            variant="unstyled"
            icon={<HamburgerIcon />}
            onClick={toggleMenu}
          />
        </Hide>
      </Flex>
      {isOpen && (
        <Flex
          position="fixed"
          height="100vh"
          overflow="hidden"
          background="white"
          zIndex="9"
          width="100%"
          direction="column"
          transition="height 0.2s ease-in-out"
          gap={6}
          p={4}
        >
          <Link onClick={toggleMenu} href="/#invest-in-land">
            {t('invest-in-land')}
          </Link>
          <Link onClick={toggleMenu} href="/#why">
            {t('why-buy')}
          </Link>
          <Link onClick={toggleMenu} href="/team">
            {t('who-we-are')}
          </Link>
          <Link onClick={toggleMenu} href="/faqs">
            {t('frequent-questions')}
          </Link>
          <Link onClick={toggleMenu} href="/#help-center">
            {t('help-center')}
          </Link>
          <Link href={LandtokenSignUp} target="_blank">
            <Button style={{ width: '100%' }} variant="primary" fontWeight="normal" fontSize="sm">
              {t('sign-up', 'Registrate')}
            </Button>
          </Link>
          <Link href={LandtokenLogin} target="_blank">
            <Button style={{ width: '100%' }} variant="outline" fontWeight="normal" fontSize="sm">
              {t('sign-in', 'Iniciar sesión')}
            </Button>
          </Link>
        </Flex>
      )}
    </chakra.header>
  );
}
export default Header;
